export default __webpack_public_path__ + "static/media/Visual_joil_01.48b3c275.jpg";